<!-- <link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" /> -->
<div class="k-overlay" *ngIf="editWinOpen"></div>

<!-- <kendo-window-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-form-element"></span> Manage Releases for {{project}}
  </div>
</kendo-window-titlebar> -->

<ng-template #windowTitleBar let-win>
  <span class="k-window-title">
    <span *ngIf="formMode == FormModes.EDIT" class="k-icon k-font-icon k-icon-xl k-i-edit"></span> 
    <span *ngIf="formMode == FormModes.NEW" class="k-icon k-font-icon k-icon-xl k-i-plus-circle"></span> 
    <span *ngIf="formMode == FormModes.NOTSET" class="k-icon k-font-icon k-icon-xl k-i-eye"></span>
    {{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>

<div class="container" my-5>
  <!-- <div class="card" #appendTo>
    <div class="card-body no-border"> -->
      <!-- <div class="card-title">
        <h3 style="text-align: left;" class="page-header">
          <fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'list-check']"></fa-icon> Manage Releases for {{project}}
        </h3>
      </div> -->

      <kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true"
        [groupable]="true" [resizable]="true" [filter]="filter" filterable="menu" (filterChange)="filterChange($event)"
        (sortChange)="sortChange($event)" [height]="600" [pageSize]="pageSize"
        [pageable]="true">

        <ng-template kendoGridToolbarTemplate position="top">
          <button (click)="onAddRelease(windowTitleBar)" kendoButton class="btn btn-primary">
            <fa-icon icon="circle-plus"></fa-icon> Add Release
          </button>
        </ng-template>

        <kendo-grid-column title="Edit" [width]="70">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onEditClick(dataItem, windowTitleBar)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="edit"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="View" [width]="70">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onViewClick(dataItem, windowTitleBar)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="eye"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Report" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onReportClick(dataItem)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="file-pdf"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <!-- <kendo-grid-column field="project_name" title="Project">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column> -->

        <kendo-grid-column field="comment" title="Comment/Git Version Number" [width]="300">
            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
              let-filterService="filterService">
              <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
            </ng-template>
          </kendo-grid-column>

        <kendo-grid-column field="released_by_user" title="Released By" [width]="250">
            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
              let-filterService="filterService">
              <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="release_date" title="Released Date">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.release_date | date: 'dd/MM/yyyy'}}
          </ng-template>
            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
              let-filterService="filterService">
              <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Delete" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onConfirmDelete(dataItem)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="trash"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <ng-template kendoPagerTemplate>
          <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
        </ng-template>

      </kendo-grid>
      <button kendoButton (click)="onClose()" class="btn btn-primary btn-right">Close</button>
    <!-- </div>
  </div> -->

</div>


<div kendoDialogContainer></div>

<!-- <div kendoWindowContainer></div> -->
